import {toastr} from 'react-redux-toastr';
import {
  putJsonAsync,
  postJsonAsync,
  getJsonAsync
} from 'shared/actions';
import {initialize} from 'redux-form';
 import {
   deactivateProcessStart,
   deactivateProcessEnd,
   cancelDeactivateModal,
   displayActiveBundlingRules,
   displayNewBundlingRule,
   setBundlingRuleEventsInState,
   cancelBundlingRuleItemForm
 } from './actionTypes';

 export const deactivateBundlingRule = ruleId => (dispatch, getState) => {
   const tournament = getState().tournament.base.tournamentInfo;

   dispatch(deactivateProcessStart());
   dispatch(putJsonAsync(`bundling/${ruleId}/deactivate`))
   .then(() => {
     dispatch(deactivateProcessEnd());
     dispatch(cancelDeactivateModal());
     dispatch(retrieveActiveBundles(tournament.id));
     toastr.success('Saved!', 'Bundling rule deactivated successfully.');
   })
   .catch(() => dispatch(deactivateProcessEnd()));
 };

export const retrieveBundlingRuleEvents = tournamentId => dispatch => {
  dispatch(getJsonAsync(`bundling/${tournamentId}/bundlingruleevents/`))
  .then(data => dispatch(setBundlingRuleEventsInState(data.map(({id, displayName}) => ({
    value: id,
    label: displayName
  })))));
};

export const validate = values => {
  let errors = {};

  if(!values.parentEventId) {
    errors.parentEventId = 'Required';
  }
  if(!values.childEventId) {
    errors.childEventId = 'Required';
  }
  if(!values.quantity) {
    errors.quantity = 'Required';
  }
  if(values.parentEventId && values.childEventId
    && values.parentEventId === values.childEventId){
     errors.childEventId = 'Cannot be the same as parent event';
  }

  return errors;
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const tournament = getState().tournament.base.tournamentInfo;

  dispatch(postJsonAsync('bundling', {
    ...data,
    tournamentId: tournament.id
  }))
  .then(() => {
    toastr.success('Saved!', 'Bundling Rule saved successfully.');
    dispatch(retrieveActiveBundles(tournament.id));
    resolve();
  })
  .catch(() => resolve());
});

export const handleCancel = () => dispatch => dispatch(cancelBundlingRuleItemForm());

export const handleNewBundlingRuleClick = () => dispatch => {
  dispatch(cancelBundlingRuleItemForm());
  dispatch(displayNewBundlingRule());
  dispatch(initialize('bundlingRuleItemForm', {}));
};

export const retrieveActiveBundles = tournamentId => dispatch => {
  dispatch(getJsonAsync(`bundling/${tournamentId}/active`))
  .then(data => dispatch(displayActiveBundlingRules(data)));
};



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/actions.js